export default __webpack_public_path__ + "static/small-image-bimp-4-e3dc4589b45f0e55b68352287626efeb.png";